import { memo, type ReactNode, useMemo } from 'react'

import { DataTable } from '@/components/data-table/data-table.organism'
import { cn } from '@/lib/utils'

import { createMemberActionList, createMemberColumnList } from './member-table.config'
import type { MembersListSectionProps, OrganizationMember } from './members.interface'

const MembersListSectionBase: React.FC<MembersListSectionProps> = ({
  memberList,
  currentUserId,
  canManageMembers,
  isLoading = false,
  onRoleChange,
  onRemoveMember,
  className,
}): ReactNode => {
  const columnList = useMemo(
    () => createMemberColumnList(canManageMembers, onRoleChange),
    [canManageMembers, onRoleChange]
  )

  const actionList = useMemo(
    () => createMemberActionList(canManageMembers, currentUserId, onRemoveMember),
    [canManageMembers, currentUserId, onRemoveMember]
  )

  const getRowId = (row: OrganizationMember): string => row.id

  return (
    <div className={cn('members-list-section', className)}>
      <DataTable
        data={memberList}
        columnList={columnList}
        getRowId={getRowId}
        actionList={actionList}
        isLoading={isLoading}
        emptyMessage="No members found"
      />
    </div>
  )
}

export const MembersListSection = memo(MembersListSectionBase)

MembersListSection.displayName = 'MembersListSection'
